import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";

const API_BASE = "https://portal.gmacc.co.za/api";

/* ---------- (Speciality removed from UI per request, constants kept if needed elsewhere) ---------- */
const ACCOUNT_TYPE_SELECT = [{ label: "Current (Main)", value: 121510000 }];

const BANKS = [
  { name: "Absa", id: "6aec65c3-3254-ed11-bba2-000d3adf7aa1" },
  { name: "Access Bank", id: "a1355640-b177-ee11-8179-000d3adf7aa1" },
  { name: "African Bank", id: "35769190-5d4a-ee11-be6f-000d3adea7d6" },
  { name: "Albaraka Bank", id: "45d610f1-eea3-ee11-bbfe-000d3adf7aa1" },
  { name: "Bank of Athens", id: "5b0f53c7-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Barclays Bank", id: "bf0567-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Bidvest Bank", id: "da4164ab-2356-ed11-bba2-000d3adf7aa1" },
  { name: "Capitec Bank", id: "7a0e0bbe-2256-ed11-bba2-000d3adf7aa1" },
  { name: "Capitec Business", id: "6b0a7bec-cee8-ee11-a569-000d3adf7aa1" },
  { name: "Discovery Bank", id: "aaa8062e-20c1-ee11-8179-000d3adf7aa1" },
  { name: "First National Bank", id: "5773f52c-3534-ed11-bba2-000d3adf79f4" },
  { name: "FirstRand Bank", id: "6ac5173a-8f50-ee11-be6e-000d3adf79f4" },
  { name: "HSBC Bank", id: "8020507f-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Investec", id: "68727213-2356-ed11-bba2-000d3adf79f4" },
  { name: "Mercantile Bank", id: "49175085-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Nedbank", id: "31cd3060-3534-ed11-bba2-000d3adf79f4" },
  { name: "Old Mutual", id: "91549f1f-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Rand Merchant Bank", id: "643a02b0-8f50-ee11-be6e-000d3adf79f4" },
  { name: "RMB Private Bank", id: "a5d3a0b2-8f50-ee11-be6e-000d3adf79f4" },
  { name: "Sasfin Bank Limited", id: "fa9e83e8-8f50-ee11-be6e-000d3adf79f4" },
  {
    name: "South African Post Bank",
    id: "a3e6b193-3354-ed11-bba2-000d3adf7aa1",
  },
  { name: "Standard Bank", id: "c12293b9-434e-ee11-be6e-000d3adea7d6" },
  {
    name: "Standard Chartered Bank",
    id: "1936b984-54d4-ee11-bee4-000d3adea7d6",
  },
  { name: "Tyme Bank", id: "2a5b8c2a-65aa-ee11-bee4-000d3adea7d6" },
];

/* Document type options for company registration proof */
const COMPANY_DOC_TYPES = [
  "CoR14.3 / CIPC Registration Certificate",
  "CK / Founding Statement",
  "Memorandum of Incorporation (MOI)",
  "Partnership / Sole Proprietor Registration",
  "Other",
];

export default function ContractorRegPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    company_name: "",
    registration_number: "",
    vat_number: "",
    // moved into Company Details:
    email: "",
    phone: "",

    contact_firstname: "",
    contact_lastname: "",
    contact_email: "",
    contact_phone: "",

    // VAT flow
    vat_registered: "no", // "yes" | "no"

    // Company registration doc type
    company_doc_type: "",

    // Passwords
    password: "",
    confirm_password: "",

    // Disclaimer (must be accepted)
    disclaimer_accepted: false,

    bank_account_name: "",
    bank_id: "",
    bank_account_number: "",
    bank_account_type: "",
  });

  const [files, setFiles] = useState({
    cipc_doc: null, // Company registration doc (required)
    vat_doc: null, // VAT confirmation letter (required only if VAT registered)
    bank_proof_doc: null, // Bank account letter (required)
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [result, setResult] = useState(null);
  const [retrying, setRetrying] = useState(false);

  // show/hide toggles for password inputs
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  const requiredText = useMemo(
    () => ({
      company_name: "Company Name",
      registration_number: "Company Registration Number",
      // vat_number is conditional
      // moved up:
      email: "Company Email",
      phone: "Company Phone",

      contact_firstname: "Primary Contact First Name",
      contact_lastname: "Primary Contact Last Name",
      contact_email: "Primary Contact Email",
      contact_phone: "Primary Contact Phone",

      // VAT flow
      vat_registered: "VAT Registration (Yes/No)",
      company_doc_type: "Company Registration Document Type",

      password: "Account Password",
      confirm_password: "Confirm Password",

      bank_account_name: "Bank Account Name",
      bank_id: "Bank Name",
      bank_account_number: "Bank Account Number",
      bank_account_type: "Bank Account Type",

      // files (base required)
      cipc_doc: "Company Registration Document",
      // vat_doc is conditional
      bank_proof_doc: "Bank Account Confirmation Letter",

      // disclaimer
      disclaimer_accepted: "Confirmation of information accuracy",
    }),
    []
  );

  const update = (k) => (e) =>
    setForm((s) => ({
      ...s,
      [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    }));
  const updateFile = (k) => (e) =>
    setFiles((s) => ({ ...s, [k]: e.target.files?.[0] || null }));

  const validate = () => {
    // base required (excluding conditional VAT bits)
    const baseKeys = [
      "company_name",
      "registration_number",
      "email",
      "phone",
      "contact_firstname",
      "contact_lastname",
      "contact_email",
      "contact_phone",
      "vat_registered",
      "company_doc_type",
      "password",
      "confirm_password",
      "bank_account_name",
      "bank_id",
      "bank_account_number",
      "bank_account_type",
      "disclaimer_accepted",
    ];

    const missingFields = [];
    baseKeys.forEach((k) => {
      const val = form[k];
      if (typeof val === "boolean") {
        if (!val) missingFields.push(requiredText[k]);
      } else if (!String(val || "").trim()) {
        missingFields.push(requiredText[k]);
      }
    });

    // file checks (base)
    if (!files.cipc_doc) missingFields.push(requiredText.cipc_doc);
    if (!files.bank_proof_doc) missingFields.push(requiredText.bank_proof_doc);

    // conditional VAT checks
    const isVatYes = String(form.vat_registered).toLowerCase() === "yes";
    if (isVatYes) {
      if (!String(form.vat_number || "").trim()) {
        missingFields.push("VAT Number");
      }
      if (!files.vat_doc) {
        missingFields.push("VAT Confirmation Letter");
      }
    }

    if (missingFields.length) {
      setError(`Please complete the following: ${missingFields.join(", ")}`);
      return false;
    }

    if (form.password !== form.confirm_password) {
      setError("Account Password and Confirm Password must match.");
      return false;
    }

    setError("");
    return true;
  };

  // ---- Optional helper: retry only the beneficiary bank-proof upload if backend reported partial failure
  const retryBankProofUpload = async (beneficiaryId) => {
    if (!beneficiaryId || !files.bank_proof_doc) return null;
    try {
      setRetrying(true);
      const token = localStorage.getItem("token");
      const fd = new FormData();
      fd.append("file", files.bank_proof_doc, files.bank_proof_doc.name);

      const r = await fetch(
        `${API_BASE}/beneficiary/${beneficiaryId}/upload/bank-proof/`,
        {
          method: "PATCH",
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          body: fd,
        }
      );
      const j = await r.json().catch(() => ({}));
      setRetrying(false);
      return { ok: r.ok, status: r.status, payload: j };
    } catch (e) {
      setRetrying(false);
      return { ok: false, status: 0, payload: { error: String(e) } };
    }
  };

  const preCheckDuplicateRegNo = async (regNo) => {
    if (!regNo) return { ok: false, reason: "missing reg" };
    const url = `${API_BASE}/contractors/by-registration/${encodeURIComponent(
      regNo
    )}/`;
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      if (!res.ok) {
        // let backend enforce
        return { ok: true, count: 0 };
      }
      const json = await res.json().catch(() => ({}));
      const count = Number(
        json?.count || (Array.isArray(json?.value) ? json.value.length : 0)
      );
      return { ok: true, count };
    } catch {
      return { ok: true, count: 0 };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setResult(null);
    if (!validate()) return;

    // Client-side duplicate check
    const dup = await preCheckDuplicateRegNo(form.registration_number);
    if (dup.ok && dup.count > 0) {
      setError(
        "A contractor with that Registration Number already exists on our system."
      );
      return;
    }

    setSubmitting(true);
    try {
      const fd = new FormData();

      // text fields (only current keys)
      Object.entries(form).forEach(([k, v]) => {
        // send booleans as "true/false" to be explicit
        if (typeof v === "boolean") fd.append(k, v ? "true" : "false");
        else if (v !== undefined && v !== null) fd.append(k, String(v));
      });

      // files
      if (files.cipc_doc)
        fd.append("cipc_doc", files.cipc_doc, files.cipc_doc.name);
      if (files.vat_doc)
        fd.append("vat_doc", files.vat_doc, files.vat_doc.name);
      if (files.bank_proof_doc)
        fd.append(
          "bank_proof_doc",
          files.bank_proof_doc,
          files.bank_proof_doc.name
        );

      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE}/contractor/register/`, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: fd,
      });

      const raw = await res.text();
      let json;
      try {
        json = raw ? JSON.parse(raw) : {};
      } catch {
        json = {};
      }

      if (!res.ok) {
        const msg =
          (json && (json.error || json.detail)) || raw || "Registration failed";
        throw new Error(msg);
      }

      setResult(json);
      setSuccess("Thanks! Your application has been submitted.");

      // If the only failure was the bank-proof upload (beneficiary created & linked), auto-retry once.
      const needRetry =
        json &&
        json.beneficiary_id &&
        json.file_uploads &&
        json.file_uploads.bank_proof_doc &&
        json.file_uploads.bank_proof_doc.ok === false &&
        !!files.bank_proof_doc;

      if (needRetry) {
        const retry = await retryBankProofUpload(json.beneficiary_id);
        if (retry && retry.ok) {
          setResult((r) => ({
            ...(r || {}),
            file_uploads: {
              ...(r?.file_uploads || {}),
              bank_proof_doc: { ok: true, retried: true },
            },
          }));
        } else if (retry) {
          setError(
            `Application saved, but bank proof upload failed (status ${retry.status}). You can retry later in the portal.`
          );
        }
      }

      // ✅ Redirect to login page after success
      setTimeout(() => navigate("/"), 1000);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  const isVatYes = String(form.vat_registered).toLowerCase() === "yes";

  return (
    <div className={styles.page}>
      {/* MAIN 50/50 LAYOUT – image + form */}
      <div className={styles.regcontractorFrame}>
        {/* LEFT IMAGE */}
        <div className={styles.regcontractorMedia} aria-hidden="true"></div>

        {/* RIGHT PANEL */}
        <div className={styles.regcontractorPanel}>
          {/* FORM CARD */}
          <form className={styles.regcontractorCard} onSubmit={handleSubmit}>
            <img
              src={logoimage}
              alt="Gauteng Management Agents"
              className={styles.regcontractorLogo}
            />
            <h1 className={styles.regcontractorheading}>
              Contractor Registration
            </h1>

            <p className={styles.regcontractorsubhead}>
              Complete your company, primary contact, bank and document details
              to register as a contractor with GMA.
            </p>

            {error && <p className={styles.errorText}>{error}</p>}
            {success && <p className={styles.successText}>{success}</p>}

            {/* COMPANY DETAILS */}
            <h2 className={styles.regcontractorcardTitle}>Company Details</h2>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Company Name *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.company_name}
                    onChange={update("company_name")}
                  />
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Registration Number *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.registration_number}
                    onChange={update("registration_number")}
                  />
                </div>
              </div>
            </div>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  VAT Registered? *
                </label>

                <div className={styles.regcontractorRadioRow}>
                  <label>
                    <input
                      type="radio"
                      name="vat_registered"
                      value="yes"
                      checked={form.vat_registered === "yes"}
                      onChange={update("vat_registered")}
                    />
                    Yes
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="vat_registered"
                      value="no"
                      checked={form.vat_registered === "no"}
                      onChange={update("vat_registered")}
                    />
                    No
                  </label>
                </div>
              </div>

              {isVatYes && (
                <div className={styles.regcontractorinputGroup}>
                  <label className={styles.regcontractorinputLabel}>
                    VAT Number *
                  </label>
                  <div className={styles.regcontractorinputShell}>
                    <input
                      className={styles.input}
                      value={form.vat_number}
                      onChange={update("vat_number")}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Company Phone *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.phone}
                    onChange={update("phone")}
                  />
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Company Email *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    type="email"
                    className={styles.input}
                    value={form.email}
                    onChange={update("email")}
                  />
                </div>
              </div>
            </div>

            {/* PRIMARY CONTACT */}
            <h2 className={styles.regcontractorcardTitle}>Primary Contact</h2>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  First Name *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.contact_firstname}
                    onChange={update("contact_firstname")}
                  />
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Last Name *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.contact_lastname}
                    onChange={update("contact_lastname")}
                  />
                </div>
              </div>
            </div>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Phone *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.contact_phone}
                    onChange={update("contact_phone")}
                  />
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Email *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    type="email"
                    className={styles.input}
                    value={form.contact_email}
                    onChange={update("contact_email")}
                  />
                </div>
              </div>
            </div>

            {/* PASSWORDS */}
            <h2 className={styles.regcontractorcardTitle}>Account Login</h2>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Account Password *
                </label>

                <div className={styles.regcontractorPasswordWrap}>
                  <input
                    className={styles.regcontractorInput}
                    type={showPwd ? "text" : "password"}
                    value={form.password}
                    onChange={update("password")}
                  />
                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={() => setShowPwd((s) => !s)}
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                    </svg>
                  </button>
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Confirm Password *
                </label>

                <div className={styles.regcontractorPasswordWrap}>
                  <input
                    className={styles.regcontractorInput}
                    type={showConfirmPwd ? "text" : "password"}
                    value={form.confirm_password}
                    onChange={update("confirm_password")}
                  />
                  <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={() => setShowConfirmPwd((s) => !s)}
                  >
                    <svg viewBox="0 0 24 24">
                      <path d="M12 5c-5 0-9 4.5-9 7s4 7 9 7 9-4.5 9-7-4-7-9-7zm0 11a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            {/* BANK DETAILS */}
            <h2 className={styles.regcontractorcardTitle}>Bank Details</h2>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Account Name *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.bank_account_name}
                    onChange={update("bank_account_name")}
                  />
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Bank Name *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <select
                    className={styles.input}
                    value={form.bank_id}
                    onChange={update("bank_id")}
                  >
                    <option value="">Select…</option>
                    {BANKS.map((b) => (
                      <option key={b.id} value={b.id}>
                        {b.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className={styles.regcontractortwoCol}>
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Account Number *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input
                    className={styles.input}
                    value={form.bank_account_number}
                    onChange={update("bank_account_number")}
                  />
                </div>
              </div>

              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  Account Type *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <select
                    className={styles.input}
                    value={form.bank_account_type}
                    onChange={update("bank_account_type")}
                  >
                    <option value="">Select…</option>
                    {ACCOUNT_TYPE_SELECT.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* DOCUMENTS */}
            <h2 className={styles.regcontractorcardTitle}>Documents</h2>

            <div className={styles.regcontractorinputGroup}>
              <label className={styles.regcontractorinputLabel}>
                Company Registration Document Type *
              </label>
              <div className={styles.regcontractorinputShell}>
                <select
                  className={styles.input}
                  value={form.company_doc_type}
                  onChange={update("company_doc_type")}
                >
                  <option value="">Select…</option>
                  {COMPANY_DOC_TYPES.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.regcontractorinputGroup}>
              <label className={styles.regcontractorinputLabel}>
                Company Registration Document *
              </label>
              <div className={styles.regcontractorinputShell}>
                <input type="file" onChange={updateFile("cipc_doc")} />
              </div>
            </div>

            {isVatYes && (
              <div className={styles.regcontractorinputGroup}>
                <label className={styles.regcontractorinputLabel}>
                  VAT Confirmation Letter *
                </label>
                <div className={styles.regcontractorinputShell}>
                  <input type="file" onChange={updateFile("vat_doc")} />
                </div>
              </div>
            )}

            <div className={styles.regcontractorinputGroup}>
              <label className={styles.regcontractorinputLabel}>
                Bank Account Confirmation Letter *
              </label>
              <div className={styles.regcontractorinputShell}>
                <input type="file" onChange={updateFile("bank_proof_doc")} />
              </div>
            </div>

            {/* DISCLAIMER */}
            <div
              className={styles.regcontractorinputGroup}
              style={{ marginTop: 8, textAlign: "left" }}
            >
              <label className={styles.regcontractorinputLabel}>
                Declaration *
              </label>

              <div className={styles.regcontractorcheckboxRow}>
                <input
                  type="checkbox"
                  checked={form.disclaimer_accepted}
                  onChange={update("disclaimer_accepted")}
                />
                <label>
                  I confirm that all information provided is true and correct. I
                  authorize GMA to verify the information supplied. I
                  acknowledge that GMA will not be held responsible for any
                  discrepancies or losses arising from incorrect information
                  provided by me/us.
                </label>
              </div>
            </div>

            {/* BUTTONS */}
            <div className={styles.regcontractorbuttonBar}>
              <button
                className={styles.redButton}
                disabled={submitting}
                type="submit"
              >
                {submitting ? "Submitting…" : "Submit Application"}
              </button>

              <button
                type="button"
                className={styles.darkButton}
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>

            <p className={styles.statementNote}>
              By submitting, you consent to processing your information for
              verification and supplier onboarding.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
